import { InjectionToken } from '@angular/core';
import { DataModuleConfiguration } from '../models';

export const CONFIGURATIONS: InjectionToken<DataModuleConfiguration[]> = new InjectionToken<DataModuleConfiguration[]>(
  '@cue/data-configurations'
);
